
import React from 'react';
import { cn } from "@/lib/utils"
import { GridCell } from './grid-cell';

interface GridRowProps {
  rowIndex: number;
  columns: number;
  isMobile: boolean;
  finalItems: any[];
  rowRef: (el: HTMLDivElement | null) => void;
}

export function GridRow({ rowIndex, columns, isMobile, finalItems, rowRef }: GridRowProps) {
  return (
    <div
      className={cn(
        "grid will-change-transform will-change-filter relative",
        isMobile
          ? "gap-[0.5rem] grid-cols-4" // Keep the gap consistent
          : "gap-[clamp(0.6rem,2.4vw,0.9rem)] grid-cols-[repeat(7,minmax(clamp(185px,26.4vw,317px),1fr))]"
      )}
      ref={rowRef}
      style={{
        gridAutoRows: isMobile ? "180px" : "auto", // Increased cell height from 160px to 180px
        width: isMobile ? "100%" : "auto" // Make sure row takes full width of parent
      }}
    >
      {[...Array(columns)].map((_, itemIndex) => {
        const arrayIndex = rowIndex * columns + itemIndex;
        const content = finalItems[arrayIndex];

        return (
          <GridCell
            key={itemIndex}
            content={content}
            rowIndex={rowIndex}
            itemIndex={itemIndex}
            arrayIndex={arrayIndex}
            isMobile={isMobile}
          />
        );
      })}
    </div>
  );
}
